import {Box, Flex, Text} from 'exsportia-components'
import React, {FC} from 'react'
import {NavigateFunction} from 'react-router-dom'

import {AppearanceTemplateElement} from '../../../api/display-settings/types'
import {TranslatorScope} from '../../../locale/types'
import {LocaleOptions} from '../../../utils/i18n'
import {validationTokensMap} from '../../select-service/select-service-page'

type SubscriptionTileData = {
  name: string
  logo?: {secure_url?: string}
  permissionData?: {reason?: string; validated: boolean}
}

export type SubscriptionTileProps = {
  l: (scope: TranslatorScope, options?: LocaleOptions) => string
  item: AppearanceTemplateElement
  navigate: NavigateFunction
  isMemberBlocked?: boolean
  cardWidth?: string | [string, string]
}

// A subscription as a pass card (D199 Grid/Carousel): cover image or gradient,
// name over a legibility overlay — the MBA pass-rail look. Deliberately
// price-less, like the row it replaces: the layout item's joined data has no
// verified price shape.
export const SubscriptionTile: FC<SubscriptionTileProps> = ({l, item, navigate, isMemberBlocked, cardWidth}) => {
  const itemData = item.data as unknown as SubscriptionTileData
  const unvalidated = isMemberBlocked || !itemData.permissionData?.validated
  const reason = itemData.permissionData?.reason as keyof typeof validationTokensMap | undefined
  const imageUrl = itemData.logo?.secure_url
  return (
    <Flex
      width={cardWidth ?? ['calc(50% - 8px)', 'calc(33.333% - 11px)']}
      flexDirection='column'
      cursor={unvalidated ? 'default' : 'pointer'}
      onClick={unvalidated ? undefined : () => navigate(`./subscription/${item.entityId}`)}
    >
      <Box
        width='100%'
        pt='62.5%'
        position='relative'
        borderRadius='16px'
        overflow='hidden'
        background={
          imageUrl
            ? `url(${imageUrl}) center/cover no-repeat`
            : 'linear-gradient(135deg, #1D2B44, #3E5C76)'
        }
      >
        <Box
          position='absolute'
          top='0'
          left='0'
          width='100%'
          height='100%'
          background='linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.15) 55%, rgba(0,0,0,0.05))'
        />
        <Box
          position='absolute'
          bottom='12px'
          left='12px'
          right='12px'
        >
          <Text
            text={itemData.name}
            settings={{color: '#FFFFFF', fontWeight: 700, croppedLines: 2}}
          />
          {!isMemberBlocked && unvalidated && reason && (
            <Text
              text={l(validationTokensMap[reason], {caseAction: 'capitalize'})}
              settings={{color: 'rgba(255,255,255,0.8)', fontSize: '12px'}}
            />
          )}
        </Box>
      </Box>
    </Flex>
  )
}
